// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidemenu[data-v-75df4c3c]{height:auto}", ""]);
// Exports
module.exports = exports;
